var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "wrapper",
      class: _vm.$style.virtualListWrapper,
      style: _vm.wrapperStyle,
    },
    [
      _vm._t("header"),
      _c(
        "div",
        { class: _vm.$style.virtualListInner, style: _vm.innerStyle },
        [
          _vm._l(_vm.items, function (item) {
            return [
              _c(
                "div",
                {
                  key: _vm.getKey ? _vm.getKey(item.index) : item.index,
                  style: item.style,
                },
                [
                  _vm._t(
                    "default",
                    function () {
                      return [_vm._v(" Missing Template ")]
                    },
                    { index: _vm.getKey ? _vm.getKey(item.index) : item.index }
                  ),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }